import { InjectionKey } from 'vue';
import { ServiceManager } from './service.manager';

export function destroyService<T>(injectKey: string | symbol | InjectionKey<T>): void {
  const serviceManager = new ServiceManager();

  serviceManager.unregisterService(injectKey);
}
